import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

const SUPPORTED_LANGUAGES = ['en', 'fr', 'de'];

@Injectable({
  providedIn: 'root'
})
export class LanguageService
{
  public static createTranslateLoader = (http: HttpClient) =>
  {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }

  private setLanguage()
  {
    const language = this.translate.getBrowserLang();
    if ((typeof language === 'string') && (SUPPORTED_LANGUAGES.includes(language)))
    {
      this.translate.setDefaultLang(language);
    }
    else
    {
      this.translate.setDefaultLang(SUPPORTED_LANGUAGES[0]);
    }
  }
  constructor(private translate: TranslateService)
  {
    this.setLanguage();
  }

  onReady()
  {
    // retry if Language is not set
    if (!this.translate.getDefaultLang())
    {
      this.setLanguage();
    }
  }
}
